import { Component, OnInit } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from '../../../core/auth/auth.service';
import { UserService } from '../../../core/user.service';
import * as Chart from "chart.js";
@Component({
  selector: 'app-cqm-ns-defect',
  templateUrl: './cqm-ns-defect.component.html',
  styleUrls: ['./cqm-ns-defect.component.css']
})
export class CqmNsDefectComponent implements OnInit {
  hostUrl =this.userService.getUrl();
  projectId: any;
  sourceDetails: any;
  sourceNames: any = [];
  assignTo =false;
  sentiment = false;
  userId: any;
  constructor(private http: HttpClient, private authService: AuthService, private route: ActivatedRoute,  private userService: UserService) { }

  ngOnInit() {
    this.authService.user() .subscribe(
      data => {});
      this.userId = localStorage.getItem("userid");

    this.projectId = localStorage.getItem("projectId");
    if(this.projectId){
    this.http.get(encodeURI(this.hostUrl+'/configure/projectSourceId/' + this.projectId))
      .subscribe(data => {
        this.sourceDetails = data;
        for(let i =0; i<this.sourceDetails.length; i++){
          this.sourceNames.push(this.sourceDetails[i].source); 
         if( this.sourceNames.includes("Service Now") ||  this.sourceNames.includes("JIRA") ||  this.sourceNames.includes("EXCEL"))
          {
           this.assignTo = true;
          }   
          else {
           this.assignTo = false;
          }
          if( this.sourceNames.includes("iOS") ||this.sourceNames.includes("IOS") ||  this.sourceNames.includes("Twitter") ||  this.sourceNames.includes("Play Store"))
          {
           this.sentiment = true; 
          }
          else {
           this.sentiment = false;
          }
       }
       });
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/cqm-ns/cqm-ns-defect/cqm-ns-defect.component.ts